export default "__VITE_ASSET__DmPKDUaZ__"